import { useI18n } from 'vue-i18n'
import { Messages } from '../translations/i18n'

export function useLocale() {
  return useI18n<{ message: Messages }, string>()
}
